/* eslint-disable @nx/enforce-module-boundaries */
import { Component, DestroyRef, inject } from '@angular/core';
import { PreloadImgComponent } from '@t-llevo/common-ui';
import { DatePipe } from '@angular/common';
import { TravelDetailsService } from '../../../services/travel-details.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DetailTabItemComponent } from 'admin-drivers/src/app/common/components/detail-tab-item/detail-tab-item.component';
import { TabElementContent } from 'admin-drivers/src/app/common/components/detail-tab-item/models/TabElement';
import { Travel } from 'admin-drivers/src/app/common/models/Travel';

@Component({
  selector: 't-llevo-details-general-section',
  standalone: true,
  imports: [DetailTabItemComponent, PreloadImgComponent, PreloadImgComponent],
  templateUrl: './details-general-section.html',
})
export class DetailsGeneralSectionComponent {
  protected data: Travel | null = null;
  protected tabItems: TabElementContent[] = [];
  protected imageUrl: string | null = null;

  private destroyRef = inject(DestroyRef);

  constructor(private travelDetailsSrv: TravelDetailsService) {
    this.travelDetailsSrv.selectedTravel$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (data) {
          this.data = data;
          this.imageUrl = this.travelDetailsSrv.getTravelImageUrl(data);
          this.assignTabItems();
        }
      });
  }

  private assignTabItems() {
    if (this.data) {
      const travelDuration =
        Number(this.data.route.duration.replace('s', '')) / 60;
      this.tabItems = [
        {
          name: 'Fecha',
          value: new DatePipe('en-US').transform(
            this.data.createdAt,
            'dd/MM/yyyy - hh:mm a'
          ) as string,
        },
        {
          name: 'Vehículo',
          value: this.data.vehicleType.name,
        },
        {
          name: 'Cliente',
          value: `${this.data.client.firstname} ${this.data.client.lastname}`,
        },
        {
          name: 'Conductor',
          value: this.data.driver
            ? `${this.data.driver.user.firstname} ${this.data.driver.user.lastname}`
            : `SIN CONDUCTOR`,
        },
        {
          name: 'Distancia',
          value: `${this.data.route?.distanceMeters / 1000}km`,
        },
        {
          name: 'Duración',
          value: `${travelDuration} minuto${travelDuration > 1 ? 's' : ''}`,
        },
        {
          name: 'Origen',
          value: this.data.originAddress,
        },
        {
          name: 'Destino',
          value: this.data.destinationAddress,
        },
        {
          name: 'Latitud de origen',
          value: `${this.data.latitudeOrigin}`,
        },
        {
          name: 'Longitud de origen',
          value: `${this.data.longitudeOrigin}`,
        },
        {
          name: 'Latitud de destino',
          value: `${this.data.latitudeDestination}`,
        },
        {
          name: 'Longitud de destino',
          value: `${this.data.longitudeDestination}`,
        },
      ];
    }
  }
}
